/**
 * Created by alex.y on 8/1/2017.
 */
export class Tuple<T1, T2> {
    constructor(public Key: T1, public Value: T2) {
    }
}


// WEBPACK FOOTER //
// ./app/objects/common/Tuple.ts